import React from 'react';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import { waLink } from '../lib/whatsapp';

const { FiArrowUpRight, FiInstagram, FiMail } = FiIcons;
const { FaWhatsapp, FaPinterestP, FaLinkedinIn } = FaIcons;

function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="footer-newsletter">
          <p className="eyebrow eyebrow-light">Stay in touch</p>
          <h2>
            Notes from
            <br />
            the <em>studio.</em>
          </h2>
          <p className="footer-newsletter-text">
            Occasional letters on materials, process, and the homes we're making. No noise, just the good stuff.
          </p>
          <button
            className="footer-subscribe"
            type="button"
            onClick={() => window.open(waLink("Hello Forma Interiors, I'd like to subscribe to your newsletter."), '_blank', 'noopener')}
          >
            Subscribe via WhatsApp
            <SafeIcon icon={FiArrowUpRight} />
          </button>
        </div>

        <div className="footer-columns">
          <div className="footer-col">
            <h4>Studio</h4>
            <a href="#studio">About us</a>
            <a href="#process">Our process</a>
            <a href="#awards">Recognition</a>
            <a href="#journal">Journal</a>
          </div>
          <div className="footer-col">
            <h4>Work</h4>
            <a href="#work">All projects</a>
            <a href="#featured">Featured</a>
            <a href="#services">Services</a>
            <a href="#testimonials">Testimonials</a>
          </div>
          <div className="footer-col">
            <h4>Contact</h4>
            <a
              href={waLink("Hello Forma Interiors, I'd like to discuss a project.")}
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp us
            </a>
            <a
              href={waLink("Hello Forma Interiors, I'd like to subscribe to your newsletter.")}
              target="_blank"
              rel="noopener noreferrer"
            >
              Newsletter
            </a>
            <a
              href={waLink("Hello Forma Interiors, I'd like to book a consultation.")}
              target="_blank"
              rel="noopener noreferrer"
            >
              Book a consult
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <a className="wordmark footer-wordmark" href="#top" aria-label="Forma Studio home">
          <span className="wordmark-icon">F.</span>
          <span className="wordmark-name">FORMA<span>INTERIORS</span></span>
        </a>
        <div className="footer-social">
          <a href={waLink()} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
            <SafeIcon icon={FaWhatsapp} />
          </a>
          <a href="https://www.instagram.com/" target="_blank" rel="noreferrer" aria-label="Instagram">
            <SafeIcon icon={FiInstagram} />
          </a>
          <a href="https://www.pinterest.com/" target="_blank" rel="noreferrer" aria-label="Pinterest">
            <SafeIcon icon={FaPinterestP} />
          </a>
          <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <SafeIcon icon={FaLinkedinIn} />
          </a>
        </div>
        <span className="copyright">© {new Date().getFullYear()} Forma Interiors · All rights reserved</span>
      </div>
    </footer>
  );
}

export default SiteFooter;
